import { PredefinedRuleSet } from "@/Appointments/Api/Dto/Responses/PredefinedRuleSet";
import { ServiceDefinitionWithItsRelatedCombos } from "@/Appointments/Models/Scheduling/ComboServiceModel";
import { CalendarSlotV2 } from "@/Appointments/Models/Scheduling/WorkDayV2";
import { SchedulingStore } from "@/Appointments/Stores/SchedulingStore";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class OpenScheduleTabHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.OpenScheduleTab.ChangeComboServiceSelection, this.ChangeComboServiceSelection);
        this.RegisterOperation(LocalOperations.OpenScheduleTab.SelectExistingRuleset, this.SelectExistingRuleset);
        this.RegisterOperation(LocalOperations.OpenScheduleTab.ClearRulesetInfo, this.ClearRulesetInfo);
    }

    private ChangeComboServiceSelection(request: LocalEvent, store: SchedulingStore): void {
        var selected = request.Get<Immutable.List<ServiceDefinitionWithItsRelatedCombos>>("selectedItems");
        if (selected == null)
            selected = [].toImmutable();

        store.OpenScheduleTabModel = store.OpenScheduleTabModel.set("SelectedComboServiceList", selected);
        store.OpenScheduleTabModel = store.OpenScheduleTabModel.set("SelectedRuleset", null);
    }

    private SelectExistingRuleset(request: LocalEvent, store: SchedulingStore): void {
        var selection = request.Get<CalendarSlotV2>("value");
        if (selection != null) {
            var ruleset = selection.Model as PredefinedRuleSet;
            if (ruleset != null)
                store.schedulingAction.GetRuleset(ruleset.ID);
        }
    }

    private ClearRulesetInfo(request: LocalEvent, store: SchedulingStore): void {
        store.OpenScheduleTabModel = store.OpenScheduleTabModel.set("SelectedRuleset", null);
        store.OpenScheduleTabModel = store.OpenScheduleTabModel.set("SelectedComboServiceList", [].toImmutable());
    }
}

export { OpenScheduleTabHandler };
